// W4-76 — "Remove kit" for the cart page and drawer.
//
// Add as a theme asset and include once in theme.liquid. For a merged kit the
// link's own href (the line's url_to_remove) already removes every component;
// this script makes the same link work for an UNMERGED kit (the transform did
// not apply) by removing every line that carries the same Kit reference or
// the same `_kit` token prefix in one /cart/update.js call, then reloading
// the cart section. Nothing else in the cart is touched.
(function () {
  function kitLines(cart, ref) {
    var updates = {};
    (cart.items || []).forEach(function (item) {
      var p = item.properties || {};
      var kit = typeof p._kit === "string" ? p._kit : "";
      if (p["Kit reference"] === ref || kit.indexOf("SKB1." + ref + ".") === 0) {
        updates[item.key] = 0;
      }
    });
    return updates;
  }
  document.addEventListener("click", function (event) {
    var link = event.target.closest && event.target.closest("[data-skb-remove-kit]");
    if (!link) return;
    event.preventDefault();
    var ref = link.getAttribute("data-skb-remove-kit");
    link.setAttribute("aria-busy", "true");
    fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { if (!r.ok) throw new Error("cart"); return r.json(); })
      .then(function (cart) {
        var updates = kitLines(cart, ref);
        if (Object.keys(updates).length === 0) return;
        return fetch("/cart/update.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ updates: updates }),
        }).then(function (r) { if (!r.ok) throw new Error("update"); });
      })
      .then(function () { window.location.reload(); })
      .catch(function () {
        link.removeAttribute("aria-busy");
        window.alert("We could not remove the kit. Please try again.");
      });
  });
})();
